// @flow

import React, { Fragment } from "react";

import { isEmpty, toPairs, without } from "ramda";

import { Translate } from "@quantum/i18n";

import "./resultado-ativos.css";

const mapaCodigoGrupoTraducao = {
  "0": "buscaGlobal.tipoAtivo.fundo",
  "1": "buscaGlobal.tipoAtivo.acao",
  "2": "buscaGlobal.tipoAtivo.rendaFixa",
  "3": "buscaGlobal.tipoAtivo.indices",
  "4": "buscaGlobal.tipoAtivo.benchmarkPersonalizado",
  "5": "buscaGlobal.tipoAtivo.portfolio",
  "8": "buscaGlobal.tipoAtivo.acao",
  "11": "buscaGlobal.tipoAtivo.derivativos",
  "13": "buscaGlobal.tipoAtivo.rpps",
  "16": "buscaGlobal.tipoAtivo.grupos",
  "17": "buscaGlobal.tipoAtivo.buscaAvancada",
  "20": "buscaGlobal.tipoAtivo.meusAtivos",
};

export const tipoGrupoAtivosPermitidos: Array<string> = Object.keys(
  mapaCodigoGrupoTraducao
);

export const tipoGrupoAtivosPermitidosSeries: Array<string> = without(
  ["5", "11", "16", "17"],
  tipoGrupoAtivosPermitidos
);

type Props = {
  results: any,
  onSelect: any => void,
};

const ResultadoAtivos = ({ results, onSelect }: Props) => {
  return (
    <div className="ResultadoAtivos">
      {isEmpty(results) && (
        <div className="ResultadoAtivos__vazio">
          Nenhum resultado encontrado
        </div>
      )}

      {toPairs(results)
        .filter(([, ativos]) => ativos.length > 0)
        .map(([codigoGrupo, ativos]) => (
          <Fragment key={codigoGrupo}>
            <h4 className="ResultadoAtivos__titulo">
              <Translate>{mapaCodigoGrupoTraducao[codigoGrupo]}</Translate>
            </h4>

            <div className="ResultadoAtivos__resultados">
              {ativos.map((ativo, i) => (
                <div
                  key={i}
                  className="ResultadoAtivos__resultado"
                  onClick={() => onSelect(ativo)}
                >
                  <div className="ResultadoAtivos__ativo-nome">
                    {ativo.nome}
                  </div>
                  <div className="ResultadoAtivos__ativo-info">
                    {ativo.informacaoAdicional}
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        ))}
    </div>
  );
};

export default ResultadoAtivos;
